import React from 'react';
import ProMarketingLink from '../components/Marketing/ProMarketingLink';

/** Liens internes FAQ (#1153) — libellés lisibles, texte source inchangé pour le JSON-LD. */
const FAQ_PATH_TAIL = String.raw`(?=[\s.,;:!?)»\]]|$)`;

const FAQ_PATH_LINKS: { re: RegExp; href: string; label: string }[] = [
  { re: new RegExp(String.raw`/pricing${FAQ_PATH_TAIL}`, 'g'), href: '/pricing', label: 'nos tarifs' },
  {
    re: new RegExp(String.raw`/fonctionnalites${FAQ_PATH_TAIL}`, 'g'),
    href: '/fonctionnalites',
    label: 'les fonctionnalités',
  },
];

type Segment = { type: 'text'; value: string } | { type: 'link'; href: string; label: string };

function splitMarketingFaqAnswer(answer: string): Segment[] {
  const text = String(answer ?? '');
  if (!text) return [];

  const matches: { index: number; length: number; href: string; label: string }[] = [];
  for (const { re, href, label } of FAQ_PATH_LINKS) {
    const flags = re.flags.includes('g') ? re.flags : `${re.flags}g`;
    const globalRe = new RegExp(re.source, flags);
    let m: RegExpExecArray | null;
    while ((m = globalRe.exec(text)) !== null) {
      matches.push({ index: m.index, length: m[0].length, href, label });
    }
  }
  if (matches.length === 0) return [{ type: 'text', value: text }];

  matches.sort((a, b) => a.index - b.index || b.length - a.length);
  const deduped: typeof matches = [];
  for (const hit of matches) {
    const overlaps = deduped.some(
      (d) => hit.index < d.index + d.length && hit.index + hit.length > d.index
    );
    if (!overlaps) deduped.push(hit);
  }

  const segments: Segment[] = [];
  let cursor = 0;
  for (const hit of deduped) {
    if (hit.index > cursor) {
      segments.push({ type: 'text', value: text.slice(cursor, hit.index) });
    }
    segments.push({ type: 'link', href: hit.href, label: hit.label });
    cursor = hit.index + hit.length;
  }
  if (cursor < text.length) {
    segments.push({ type: 'text', value: text.slice(cursor) });
  }
  return segments;
}

export function MarketingFaqAnswer({ answer }: { answer: string }) {
  const segments = splitMarketingFaqAnswer(answer);
  return (
    <>
      {segments.map((seg, i) =>
        seg.type === 'text' ? (
          <React.Fragment key={i}>{seg.value}</React.Fragment>
        ) : (
          <ProMarketingLink key={i} to={seg.href}>
            {seg.label}
          </ProMarketingLink>
        )
      )}
    </>
  );
}

export { splitMarketingFaqAnswer };
